import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const BUDGETS = [
  { value: "any", label: "Any budget" },
  { value: "25000", label: "Under ₹25,000" },
  { value: "5000000", label: "Under ₹50 Lac" },
  { value: "10000000", label: "Under ₹1 Cr" },
  { value: "30000000", label: "Under ₹3 Cr" },
];

export const SearchBar = ({ categories = [], defaultCategory = "any", compact = false }) => {
  const [q, setQ] = useState("");
  const [category, setCategory] = useState(defaultCategory);
  const [budget, setBudget] = useState("any");
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const p = new URLSearchParams();
    if (q) p.set("q", q);
    if (category && category !== "any") p.set("category", category);
    if (budget !== "any") p.set("max_price", budget);
    navigate(`/properties?${p.toString()}`);
  };

  return (
    <form
      onSubmit={submit}
      className={`w-full bg-card border border-border rounded-3xl md:rounded-full shadow-search hover:shadow-hover transition-shadow duration-300 grid md:grid-cols-[1.4fr_1px_1fr_1px_1fr_auto] items-center p-2 md:pl-8 md:pr-2 ${
        compact ? "max-w-2xl" : "max-w-4xl"
      }`}
      data-testid="hero-search-form"
    >
      <label className="px-4 py-3 md:px-0 cursor-text block">
        <span className="label-xs">Where</span>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search city or locality"
          className="mt-0.5 w-full bg-transparent text-sm text-foreground placeholder:text-muted-foreground outline-none"
          data-testid="hero-search-input"
        />
      </label>

      <span className="hidden md:block h-8 w-px bg-border" />

      <div className="px-4 py-3 md:px-6 border-t border-border md:border-t-0">
        <span className="label-xs">Category</span>
        <Select value={category} onValueChange={setCategory}>
          <SelectTrigger
            className="mt-0.5 h-auto border-0 p-0 text-sm shadow-none focus:ring-0 [&>svg]:opacity-50"
            data-testid="hero-category-select"
          >
            <SelectValue placeholder="Any type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="any">Any type</SelectItem>
            {categories.map((c) => (
              <SelectItem key={c.slug} value={c.slug}>
                {c.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <span className="hidden md:block h-8 w-px bg-border" />

      <div className="px-4 py-3 md:px-6 border-t border-border md:border-t-0">
        <span className="label-xs">Budget</span>
        <Select value={budget} onValueChange={setBudget}>
          <SelectTrigger
            className="mt-0.5 h-auto border-0 p-0 text-sm shadow-none focus:ring-0 [&>svg]:opacity-50"
            data-testid="hero-budget-select"
          >
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {BUDGETS.map((b) => (
              <SelectItem key={b.value} value={b.value}>
                {b.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <button
        type="submit"
        className="mt-2 md:mt-0 md:ml-2 w-full md:h-12 md:w-12 flex items-center justify-center rounded-full bg-primary text-primary-foreground py-3 md:py-0 font-semibold hover:brightness-95 active:scale-95 transition-transform duration-150"
        data-testid="property-search-submit"
      >
        <span className="flex items-center gap-2">
          <Search className="h-5 w-5" strokeWidth={2.4} />
          <span className="md:hidden">Search</span>
        </span>
      </button>
    </form>
  );
};

export default SearchBar;
